import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type AccessoryPackModalClasses =
  | 'modalTitleContainer'
  | 'modalActionsContainer'
  | 'modalContentContainer'
  | 'price'
  | 'priceSecondary'
  | 'toggleButton'
  | 'loadingContainer';

const accessoryPackModalStyles = makeStyles<ISpcTheme, AccessoryPackModalClasses>(
  ({ palette, typography }) => ({
    modalTitleContainer: {
      zIndex: 100,
      boxShadow: '0 3px 12px rgba(0,0,0,.2)',
      color: palette.text.primary,
    },
    modalActionsContainer: {
      boxShadow: '0 -3px 12px rgba(0,0,0,.2)',
    },
    modalContentContainer: {
      padding: '8px',
      background: palette.background.default,
    },
    price: {
      fontFamily: typography.fontFamily2 || typography.fontFamily,
    },
    priceSecondary: {
      fontFamily: typography.fontFamily,
    },
    toggleButton: {
      minHeight: '44px',
      width: '80%',
      minWidth: '120px',
      margin: 'auto',
    },
    loadingContainer: {
      width: '100%',
      minHeight: '200px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
  { name: 'GqlCustomise_AccessoryPackModal' },
);

export default accessoryPackModalStyles;
